import { render, staticRenderFns } from "./HwGroupCreate.vue?vue&type=template&id=151ddbb2&scoped=true&"
import script from "./HwGroupCreate.vue?vue&type=script&lang=js&"
export * from "./HwGroupCreate.vue?vue&type=script&lang=js&"
import style0 from "./HwGroupCreate.vue?vue&type=style&index=0&id=151ddbb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151ddbb2",
  null
  
)

export default component.exports